export class GeneralCategory {
    id : number;
    code : string;
    name : string;
    displayOrder : number;
    IsRequiredNote : boolean;
}